// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2DNIA","title":"Header_title__3Repc","left":"Header_left__3q0UX","clinicName":"Header_clinicName__2Uq6Z"};